<template>
        <div class="row no-gutters">
            <div class="col-sm-9">
                <l-map id="map" :zoom="zoom" :center="center" >
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                    <l-layer-group>
                        <l-marker
                                v-for="group in selectedGroups"
                                :key="group.id" :lat-lng="group | coordinates"
                                :title="group.name"
                                :icon="icon"
                        >
                            <l-popup>
                                <h2>{{ group.name }}</h2>
                                <p style="margin-top: -10px;"><i>{{ group.category.name }}</i></p>
                                <p style="margin-top: -10px;">{{ group.street }}, {{ group.zipcode }} {{ group.city }}</p>

                            </l-popup>
                            <l-tooltip :content="group.name"></l-tooltip>
                        </l-marker>
                    </l-layer-group>
                </l-map>
            </div>
            <div class="col-sm-3" style="padding-left: 10px; padding-right:10px;overflow: scroll">
                <h1>Sponsors</h1>
                <ul class="list-group">
                    <li class="list-group-item"
                        :class="{active : selectedSponsorId === null}"
                        @click="changeSponsor(null)">Geen</li>
                    <li v-for="sponsor in sponsors"
                        class="list-group-item"
                        :class="{active : selectedSponsorId === sponsor.id}"
                        @click="changeSponsor(sponsor.id)">{{ sponsor.name }}</li>
                </ul>
            </div>
        </div>
</template>

<script>
    import { LMap, LTileLayer, LMarker, LPopup, LLayerGroup, LTooltip, LControlAttribution } from 'vue2-leaflet'
    export default {
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LPopup,
            LLayerGroup,
            LTooltip
        },
        data () {
            return {
                zoom:9,
                center: L.latLng(51.10172991902015, 4.179900884628297),
                url:'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                marker: L.latLng(51.10172991902015, 4.179900884628297),
                groups : [],
                sponsors : [],
                selectedSponsorId : null,
                icon : new L.Icon.Default()
            }
        },
        computed : {
            selectedGroups : function(){
                if(this.selectedSponsorId === null){
                    return this.groups
                }

                return this.groups.filter(group => {
                    return group.sponsor_id === this.selectedSponsorId
                })
            }
        },
        filters : {
            coordinates : function(value){
                if(value.latitude === null || value.longitude === null){
                    return L.latLng(51.10172991902015, 4.179900884628297)
                }

                return L.latLng(value.latitude, value.longitude)
            }
        },
        created(){
            // remove shadow
            this.icon.options.shadowSize = [0,0];

            axios.get('/api/map')
                .then(response => {
                    this.groups = response.data.data.groups
                    this.sponsors = response.data.data.sponsors
                })
                .catch(error => {
                    console.log(error)
                })
        },
        methods : {
            changeSponsor : function(id){
                this.selectedSponsorId = id
            }
        }
    }
</script>

<style>
    html, body, #map, #app, .container-fluid, .row {
        height: 100% !important;
    }
</style>